module.exports = __webpack_public_path__ + "static/img/18.40c6d3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/18.jpg
// module id = jnUs
// module chunks = 1